import "./settings.scss";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";

function Settings({
  setShowSettingsMyRestaurant,
  restaurantName,
  restaurantCategory,
  rernderMyRestaurant,
  setRernderMyRestaurant,
  phone,
}) {
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    setValue("restaurant_name", restaurantName);
    setValue("phone", phone);
  }, [restaurantName]);

  const handleSubmitEditRestaurant = (event) => {
    const restaurantNameInput =
      document.getElementById("restaurant_name").value;
    const phoneInput = document.getElementById("phone").value;
    const restaurantcategoryInput = document.getElementById(
      "restaurant-category"
    ).value;

    console.log("restaurantNameInput", restaurantNameInput);
    console.log("restaurantName", restaurantName);

    console.log("restaurantCategory", restaurantcategoryInput);
    console.log("restaurantCategory", restaurantCategory);
    console.log(
      restaurantcategoryInput !== ""
        ? restaurantcategoryInput === restaurantCategory
        : false
    );
    if (
      restaurantNameInput === restaurantName &&
      (restaurantcategoryInput !== ""
        ? restaurantcategoryInput === restaurantCategory
        : true) &&
      phone === phoneInput
    ) {
      setErrorMessage("no changes were made");
      setMessage("");
      setRernderMyRestaurant(!rernderMyRestaurant);
    } else {
      const token = localStorage.getItem("token");
      fetch(`https://femez.onrender.com/API/restaurant/editMyRestaurant`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          restaurantName: restaurantNameInput,
          phone: phoneInput,
          restaurantCategory:
            restaurantcategoryInput !== ""
              ? restaurantcategoryInput
              : restaurantCategory,
        }),
      }).then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        } else {
          setMessage("restaurant updated successfully");
          setErrorMessage("");
          setRernderMyRestaurant(!rernderMyRestaurant);
        }
      });
    }
  };

  const DeleteRestaurant = async () => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete your restaurant account?"
    );
    if (isConfirmed) {
      const token = localStorage.getItem("token");
      console.log(restaurantName);
      await fetch(
        `https://femez.onrender.com/API/restaurant/DeleteAccount?restaurantName=${restaurantName}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => {
          // Check if the response status is OK (200)
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.text();
        })
        .then((data) => {
          localStorage.removeItem("restaurant_existence");
          navigate(`/`);
          console.log(data);
        })
        .catch((error) => {
          console.error("Fetch error:", error);
        });
    }
  };
  return (
    <div className="settings-container">
      <form onSubmit={handleSubmit(handleSubmitEditRestaurant)}>
        <div className="settings">
          <h1>Setting</h1>
          <div className="settings-inputs">
            <label className="restaurant-name-container">
              <p>Restaurant name</p>
              <input
                id="restaurant_name"
                type="text"
                onChange={(e) => setValue(e.target.value)}
                className={`${errors.restaurant_name && "invalid"}`}
                {...register("restaurant_name", {
                  required: true,
                  validate: (value) => value.trim().length > 0,
                  minLength: 2,
                  maxLength: 40,
                })}
              />
              {errors.restaurant_name &&
                errors.restaurant_name.type === "required" && (
                  <span>This field is required</span>
                )}
              {errors.restaurant_name &&
                errors.restaurant_name.type === "validate" && (
                  <span>The restaurant name cannot be empty</span>
                )}
              {errors.restaurant_name &&
                errors.restaurant_name.type === "minLength" && (
                  <span>
                    the Length of the restaurant name must be greater than or
                    equal 2 characters
                  </span>
                )}
              {errors.restaurant_name &&
                errors.restaurant_name.type === "maxLength" && (
                  <span>
                    the Length of the name-surname must be less than or equal to
                    50 characters
                  </span>
                )}
            </label>
            <label className="phone-container">
              <p>Restaurant phone</p>
              <input
                {...register("phone", {
                  required: true,
                  pattern: /^[?\d+]+$/i,
                  minLength: 8,
                  maxLength: 12,
                })}
                id="phone"
                type="tel"
                placeholder="Phone Number"
                className={`${errors.phone && "invalid"}`}
                onChange={(e) => setValue(e.target.value)}
              />

              {errors.phone && errors.phone.type === "pattern" && (
                <span>invalid phone number</span>
              )}
              {errors.phone && errors.phone.type === "required" && (
                <span>This field is required</span>
              )}
              {errors.phone && errors.phone.type === "minLength" && (
                <span>
                  The Length of the restaurant phone should be greater than or
                  equal 7 digits
                </span>
              )}
              {errors.phone && errors.phone.type === "maxLength" && (
                <span>
                  The Length of the restaurant phone should be less than or
                  equal to 12 digits
                </span>
              )}
            </label>
            <label className="restaurant-category-container">
              <p> Restaurant category</p>
              <select
                id="restaurant-category"
                onChange={(e) => setValue(e.target.value)}
              >
                <option value="">All Categories</option>
                <option value="Boulangerie/Patisserie">
                  Boulangerie/Patisserie
                </option>
                <option value="Brasserie">Brasserie</option>
                <option value="Café">Café</option>
                <option value="Crêperie">Crêperie</option>
                <option value="Bistro">Bistro</option>
                <option value="Fromagerie">Fromagerie</option>
                <option value="Poissonnerie">Poissonnerie</option>
                <option value="Charcuterie">Charcuterie</option>
                <option value="Gastronomic Restaurant">
                  Gastronomic Restaurant
                </option>
                <option value="Wine Bar">Wine Bar</option>
                <option value="French-Italian Trattoria">
                  French-Italian Trattoria
                </option>
                <option value="Vegetarian/Vegan">Vegetarian/Vegan</option>
              </select>
            </label>
          </div>
          <div className="success-message">{message}</div>
          <div className="error-message">{errorMessage}</div>

          <div className="settings-actions">
            <input
              type="submit"
              value="Save Changes"
              className="updateButton"
              id="submit"
            />
            <button
              type="button"
              onClick={() => setShowSettingsMyRestaurant(false)}
            >
              Cancel
            </button>
          </div>

          <div
            className="delete-account-link"
            onClick={() => DeleteRestaurant()}
          >
            Delete my restaurant account
          </div>
        </div>
      </form>
    </div>
  );
}

export default Settings;
